export default ":host ::ng-deep .input-fix .mat-form-field-underline {\n  bottom: 10px !important;\n}"